import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import {HotelCoral} from "./HotelCoral";


export const HotelWrapper = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h1 className="snn-section-title">Host hotel</h1>
        </section>
        <HotelCoral />
      </div>
      <Footer />
    </>
  );
};
